export default function ecSortService() {
  return {
    sortStringFactory,
    sortString,
    sortNumberFactory,
    sortNumber,
  };
}

function sortNumberFactory(direction = 'asc') {
  return direction === 'asc' ? (a, b) => a - b : (a, b) => b - a;
}

function sortStringFactory(direction = 'asc') {
  return direction === 'asc' ? (a, b) => sortString(a, b) : (a, b) => sortString(b, a);
}

function sortNumber(a, b) {
  return a - b;
}

const chunkRgx = /(_+)|([0-9]+)|([^0-9_]+)/g;
function sortString(a, b) {
  var ax = [],
    bx = [];

  a.replace(chunkRgx, function(_, $1, $2, $3) {
    ax.push([$1 || '0', $2 || Infinity, $3 || '']);
  });
  b.replace(chunkRgx, function(_, $1, $2, $3) {
    bx.push([$1 || '0', $2 || Infinity, $3 || '']);
  });

  while (ax.length && bx.length) {
    var an = ax.shift();
    var bn = bx.shift();
    var nn = an[0].localeCompare(bn[0]) || an[1] - bn[1] || an[2].localeCompare(bn[2]);
    if (nn) {
      return nn;
    }
  }

  return ax.length - bx.length;
}
